import dayjs, { type Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

const LOS_ANGELES = "America/Los_Angeles";

/** ISO 시각을 로스앤젤레스(샌프란시스코) 시간대로 변환. PST/PDT(서머타임) 자동 적용. */
export function toLosAngelesTime(isoString: string): Dayjs {
  return dayjs(isoString).tz(LOS_ANGELES);
}

/** 12:00 AM → 0:00 AM, 12:30 AM → 0:30 AM 로 표기 */
function formatTimeLA(d: Dayjs): string {
  const h24 = d.hour();
  const min = d.minute();
  if (h24 === 0) {
    return `0:${min.toString().padStart(2, "0")} AM`;
  }
  return d.format("h:mm A");
}

/** startTime, endTime(ISO 문자열)을 로스앤젤레스 기준 "h:mm A - h:mm A" 형식으로 포맷. */
export function formatTimeRangeInLA(startTime: string, endTime: string): string {
  const start = toLosAngelesTime(startTime);
  const end = toLosAngelesTime(endTime);
  return `${formatTimeLA(start)} - ${formatTimeLA(end)}`;
}
